export const brandLogoIsDefault = {
  type: "boolean"
};
